import { render, staticRenderFns } from "./LastHourDiagnosis.vue?vue&type=template&id=7552d097&scoped=true"
import script from "./LastHourDiagnosis.vue?vue&type=script&lang=ts"
export * from "./LastHourDiagnosis.vue?vue&type=script&lang=ts"
import style0 from "./LastHourDiagnosis.vue?vue&type=style&index=0&id=7552d097&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552d097",
  null
  
)

export default component.exports